import { render, staticRenderFns } from "./startupRequestEdit.vue?vue&type=template&id=00596638&scoped=true"
import script from "./startupRequestEdit.vue?vue&type=script&lang=js"
export * from "./startupRequestEdit.vue?vue&type=script&lang=js"
import style0 from "./startupRequestEdit.vue?vue&type=style&index=0&id=00596638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00596638",
  null
  
)

export default component.exports